'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'chevrons-up';
var width = 448;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M235.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-208 208c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 70.6 420.7 267.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-208-208zm208 400l-208-208c-6.2-6.2-16.4-6.2-22.6 0l-208 208c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 262.6 420.7 459.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;